import React, { createContext, useState } from 'react';

type AppParams = {
    referrer?: string;
    lang?: string;
    [key: string]: any;
};

export type AppParamsContextProps = {
    appParams: AppParams;
    setAppParams: (params: Partial<AppParams>) => void;
};

export const AppParamsContext = createContext<
    AppParamsContextProps | undefined
>(undefined);

type AppParamsProviderProps = {
    initialParams?: AppParams;
};

export const AppParamsProvider = ({
    children,
    initialParams = {},
}: React.PropsWithChildren<AppParamsProviderProps>) => {
    const [appParams, setAppParamsState] = useState<AppParams>(initialParams);

    const setAppParams = (params: Partial<AppParams>) => {
        setAppParamsState((prev) => ({ ...prev, ...params }));
    };

    return (
        <AppParamsContext.Provider value={{ appParams, setAppParams }}>
            {children}
        </AppParamsContext.Provider>
    );
};
